/* ============================================================
 * TF · Catálogos a pedido — selección de referencia y cotización.
 * Sin librerías. Misma gramática que tf-motion.js: reveals por
 * IntersectionObserver con failsafe, luz/tilt solo con puntero fino,
 * wipe por clip-path. Con prefers-reduced-motion no anima nada y todo
 * el contenido y las acciones siguen disponibles.
 * ============================================================ */
(function () {
  "use strict";
  if (window.__tfCat) return; window.__tfCat = true;

  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = matchMedia("(pointer: fine)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  function ready(fn) { document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    var root = $("[data-tfc]");
    if (!root) return;

    /* ── estado de la referencia elegida ── */
    var S = {
      product: root.getAttribute("data-tfc-product") || "",
      code: root.getAttribute("data-tfc-code") || "",
      catalog: root.getAttribute("data-tfc-catalog") || "",
      design: null, color: null, version: null, own: false
    };
    var key = "tfc:" + (S.code || S.catalog);
    try {
      var saved = JSON.parse(sessionStorage.getItem(key) || "null");
      if (saved) { S.design = saved.design; S.color = saved.color; S.version = saved.version; S.own = !!saved.own; }
    } catch (e) {}
    // ficha de diseño: el diseño de referencia es la propia ficha (no se elige, viaja con el código del producto)
    var fixedDesign = root.getAttribute("data-tfc-design-name");
    if (fixedDesign && !S.own) S.design = { code: S.code, name: fixedDesign };
    function save() { try { sessionStorage.setItem(key, JSON.stringify({ design: S.design, color: S.color, version: S.version, own: S.own })); } catch (e) {} }

    /* ── cambio de imagen principal: wipe (nunca crossfade) ── */
    var stage = $("[data-tfc-stage]");
    function show(src, alt, tag) {
      if (!stage || !src) return;
      var base = $("[data-tfc-stage-base]", stage), layer = $("[data-tfc-stage-in]", stage), li = layer && $("img", layer);
      var tagEl = $("[data-tfc-stage-tag]", stage);
      if (tagEl && tag) tagEl.textContent = tag;
      if (!base || !layer || !li || reduce) { if (base) { base.src = src; if (alt) base.alt = alt; } return; }
      if (base.getAttribute("src") === src) return;
      layer.classList.remove("is-on");
      li.onload = function () {
        void layer.offsetWidth; layer.classList.add("is-on");
        setTimeout(function () { base.src = src; if (alt) base.alt = alt; layer.classList.remove("is-on"); }, 660);
      };
      li.src = src;
    }

    /* ── resumen visible + campos ocultos ── */
    function designText() {
      if (S.own) return "Tengo mi propio diseño";
      if (S.design) return S.design.name + (S.design.code ? " (" + S.design.code + ")" : "");
      return "";
    }
    function priceText() { return S.version && S.version.price ? S.version.price + (S.version.cond ? " · " + S.version.cond : "") : ""; }
    function render() {
      var vals = {
        product: S.product, code: S.code,
        design: designText(), color: S.color ? S.color.name + " (" + S.color.code + ")" : "",
        version: S.version ? S.version.name : "", price: priceText()
      };
      $$("[data-tfc-out]").forEach(function (el) {
        var k = el.getAttribute("data-tfc-out"), v = vals[k] || "";
        if (el.tagName === "INPUT") { el.value = v; return; }
        el.textContent = v || el.getAttribute("data-empty") || "—";
        var row = el.closest("[data-tfc-row]");
        if (row) row.hidden = !v && row.hasAttribute("data-hide-empty");
      });
      var bar = $("[data-tfc-bar-sum]");
      if (bar) {
        var parts = [S.code, S.own ? "Diseño propio" : (S.design ? S.design.name : ""), S.color ? S.color.name : "", S.version ? S.version.name : ""].filter(Boolean);
        bar.innerHTML = "";
        parts.forEach(function (p, i) { var n = document.createElement(i === 0 ? "b" : "span"); n.textContent = (i ? " · " : "") + p; bar.appendChild(n); });
      }
      var own = $("[data-tfc-own-check]"); if (own) own.checked = S.own;
      wa();
    }
    function mark(group, code) {
      $$('[data-tfc-opt="' + group + '"]').forEach(function (b) {
        var on = b.getAttribute("data-code") === code;
        b.classList.toggle("is-selected", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
        var inp = $("input", b); if (inp) inp.checked = on;
      });
    }

    $$("[data-tfc-opt]").forEach(function (b) {
      var group = b.getAttribute("data-tfc-opt");
      var pick = function () {
        var d = { code: b.getAttribute("data-code"), name: b.getAttribute("data-name") };
        if (group === "design") {
          S.own = b.hasAttribute("data-own");
          S.design = S.own ? null : d;
          mark("design", d.code);
          if (!S.own) show(b.getAttribute("data-img"), d.name, d.name + " · " + d.code);
        } else if (group === "color") {
          var same = S.color && S.color.code === d.code;
          S.color = same ? null : d;
          mark("color", same ? "" : d.code);
          if (!same) show(b.getAttribute("data-img"), d.name, "Color " + d.name + " · " + d.code);
        } else if (group === "version") {
          S.version = { name: d.name, price: b.getAttribute("data-price") || "", cond: b.getAttribute("data-cond") || "" };
          mark("version", d.code);
        }
        save(); render();
      };
      if (b.tagName === "LABEL") { var inp = $("input", b); if (inp) inp.addEventListener("change", pick); }
      else b.addEventListener("click", pick);
    });

    /* restaurar selección guardada */
    if (S.own) mark("design", "own"); else if (S.design) mark("design", S.design.code);
    if (S.color) mark("color", S.color.code);
    if (S.version) $$('[data-tfc-opt="version"]').forEach(function (b) { if (b.getAttribute("data-name") === S.version.name) mark("version", b.getAttribute("data-code")); });

    /* ── panel de cotización ── */
    var drawer = $("[data-tfc-drawer]"), lastFocus = null;
    function open() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      var f = $("input:not([type=hidden]), textarea, select", drawer); if (f) setTimeout(function () { f.focus(); }, reduce ? 0 : 320);
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    $$("[data-tfc-quote-open]").forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        if (b.hasAttribute("data-own")) { S.own = true; S.design = null; mark("design", "own"); save(); render(); }
        open();
      });
    });
    $$("[data-tfc-quote-close]").forEach(function (b) { b.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) {
      if (!drawer || !drawer.classList.contains("is-open")) return;
      if (e.key === "Escape") { close(); return; }
      if (e.key !== "Tab") return;
      var f = $$("a[href], button:not([disabled]), input:not([type=hidden]), textarea, select", drawer).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    var ownCheck = $("[data-tfc-own-check]");
    if (ownCheck) ownCheck.addEventListener("change", function () { S.own = ownCheck.checked; if (S.own) { S.design = null; mark("design", "own"); } else { mark("design", ""); if (fixedDesign) S.design = { code: S.code, name: fixedDesign }; } save(); render(); });
    if (drawer && (location.hash === "#cotizar" || location.hash === "#tfc-quote" || /contact_posted=true/.test(location.search))) open();

    /* ── cantidad: aviso bajo el mínimo (no bloquea; lo confirma el vendedor) ── */
    var qty = $("[data-tfc-qty]"), qtyMsg = $("[data-tfc-qty-msg]");
    function qtyCheck() {
      if (!qty || !qtyMsg) return;
      var min = parseInt(qty.getAttribute("data-min") || "10", 10), v = parseInt(qty.value, 10);
      qtyMsg.hidden = !(v > 0 && v < min);
    }
    if (qty) { qty.addEventListener("input", function () { qtyCheck(); wa(); }); }

    /* ── WhatsApp: mensaje preparado; el cliente lo revisa y lo envía ── */
    function val(n) { var el = $('[data-tfc-in="' + n + '"]'); return el ? (el.value || "").trim() : ""; }
    function wa() {
      var a = $("[data-tfc-wa]"); if (!a) return;
      var num = (a.getAttribute("data-number") || "").replace(/\D/g, "");
      if (!num) return;
      var L = ["Hola, quiero cotizar con un vendedor:", "• Producto: " + S.product + (S.code ? " (" + S.code + ")" : "")];
      var d = designText(); if (d) L.push("• Diseño: " + d);
      if (S.color) L.push("• Color de referencia: " + S.color.name + " (" + S.color.code + ")");
      if (S.version) L.push("• Versión: " + S.version.name);
      if (val("qty")) L.push("• Cantidad: " + val("qty"));
      var p = priceText(); if (p) L.push("• Precio de referencia: " + p);
      if (val("club")) L.push("• Club o institución: " + val("club"));
      if (val("name")) L.push("• Nombre: " + val("name"));
      if (val("date")) L.push("• Fecha requerida: " + val("date"));
      if (val("budget")) L.push("• Presupuesto: " + val("budget"));
      if (val("msg")) L.push("Comentario: " + val("msg"));
      a.href = "https://wa.me/" + num + "?text=" + encodeURIComponent(L.join("\n"));
    }
    $$("[data-tfc-in]").forEach(function (el) { el.addEventListener("input", wa); });

    /* ── formulario deshabilitado en desarrollo: nunca envía ── */
    $$("form[data-tfc-noform]").forEach(function (f) { f.addEventListener("submit", function (e) { e.preventDefault(); }); });

    /* ── barra fija: aparece al pasar la cabecera ── */
    var bar = $("[data-tfc-bar]"), mark0 = $("[data-tfc-bar-after]");
    if (bar && mark0) {
      var braf = null;
      var btick = function () { braf = null; bar.classList.toggle("is-on", mark0.getBoundingClientRect().bottom < 0); };
      var bsched = function () { if (!braf) braf = requestAnimationFrame(btick); };
      window.addEventListener("scroll", bsched, { passive: true });
      window.addEventListener("resize", bsched, { passive: true });
      btick();
    } else if (bar) bar.classList.add("is-on");

    /* ── búsqueda en el catálogo (solo aparece si el catálogo es extenso) ── */
    var search = $("[data-tfc-search]");
    if (search) {
      var cards = $$("[data-tfc-card]"), count = $("[data-tfc-count]"), empty = $("[data-tfc-empty]");
      var norm = function (s) { return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); };
      search.addEventListener("input", function () {
        var q = norm(search.value), n = 0;
        cards.forEach(function (c) { var hit = !q || norm(c.getAttribute("data-tfc-card")).indexOf(q) > -1; c.hidden = !hit; if (hit) n++; });
        if (count) count.textContent = n;
        if (empty) empty.hidden = n > 0;
      });
    }

    render(); qtyCheck();

    /* ── motion: reveals + luz/tilt, igual que tf-motion.js ── */
    if (reduce) return;
    requestAnimationFrame(function () { setTimeout(motion, 0); });
  });

  function motion() {
    var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
    var fine = matchMedia("(pointer: fine)").matches;
    if (!document.documentElement.classList.contains("tf-motion")) return; // tf-motion.js no corrió: todo queda visible
    var step = 80, targets = $$(".tfc-card, .tfc-opt, .tfc-color, .tfc-panel > *, .tfc-stagewrap, .tfc-cathero__lead > *, .tfc-cathero__side");
    var perSec = new WeakMap();
    targets.forEach(function (el) {
      if (el.classList.contains("tf-reveal")) return;
      el.classList.add("tf-reveal");
      var sec = el.closest("section") || document.body, i = perSec.get(sec) || 0; perSec.set(sec, i + 1);
      el.style.transitionDelay = Math.min(i, 7) * step + "ms";
    });
    // al terminar se quitan las clases para devolver las transiciones propias (hover, selección)
    var reveal = function (el) { if (el.__tfcIn) return; el.__tfcIn = true; el.classList.add("is-in"); setTimeout(function () { el.classList.remove("tf-reveal", "is-in"); el.style.transitionDelay = ""; }, 1700); };
    setTimeout(function () { targets.forEach(reveal); }, 700 + 7 * step);
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (ents) { ents.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } }); }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
      targets.forEach(function (el) { io.observe(el); });
    } else targets.forEach(reveal);

    if (!fine) return;
    $$(".tfc-card").forEach(function (card) {
      card.addEventListener("pointermove", function (e) {
        var r = card.getBoundingClientRect(), px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        card.style.setProperty("--gx", (px * 100).toFixed(1) + "%"); card.style.setProperty("--gy", (py * 100).toFixed(1) + "%");
        card.style.setProperty("--tf-tiltx", ((py - 0.5) * -2.6).toFixed(2) + "deg"); card.style.setProperty("--tf-tilty", ((px - 0.5) * 2.6).toFixed(2) + "deg");
        card.classList.add("tf-lit");
      });
      card.addEventListener("pointerleave", function () { card.classList.remove("tf-lit"); card.style.setProperty("--tf-tiltx", "0deg"); card.style.setProperty("--tf-tilty", "0deg"); });
    });
  }
})();
